// @flow
import React from 'react';
import { connect } from 'react-redux';
import Link from 'brastrap/containers/link/LinkContainer';
import { FormattedMessage } from 'react-intl';
import { push } from '../../../actions/app/routing';

type Props = {
  basePath: BasePath,
  dispatch: any => void,
  redirectTo: string,
};

const SIGN_UP_URL = 'account-signup';

const Register = ({ basePath, dispatch, redirectTo }: Props) => {
  const url = `${basePath}${SIGN_UP_URL}`;
  const nextPathname = redirectTo;

  const onClick = () =>
    dispatch(
      push({
        pathname: url,
        state: { nextPathname },
      })
    );

  return (
    <div className="s-prose">
      <p>
        <FormattedMessage
          id="auth.register.description"
          defaultMessage="Register with us to save and access your purchase history, save details to your account and
          add styles to your saved items."
        />
      </p>
      <Link className="c-button-link" onClick={onClick}>
        <FormattedMessage id="actions.register" defaultMessage="Register" />
      </Link>
    </div>
  );
};

const mapStateToProps = ({ app: { config, routing } }) => ({
  basePath: config.basePath,
  redirectTo: routing.state && routing.state.nextPathname,
});

export default connect(mapStateToProps)(Register);
